import { render, staticRenderFns } from "./FormThuxHorizontalCheckbox.vue?vue&type=template&id=628b914e&"
import script from "./FormThuxHorizontalCheckbox.vue?vue&type=script&lang=js&"
export * from "./FormThuxHorizontalCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports